import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=5901bf53"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"
import style0 from "./Events.vue?vue&type=style&index=0&id=5901bf53&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5901bf53')) {
      api.createRecord('5901bf53', component.options)
    } else {
      api.reload('5901bf53', component.options)
    }
    module.hot.accept("./Events.vue?vue&type=template&id=5901bf53", function () {
      api.rerender('5901bf53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Events.vue"
export default component.exports